// src/features/profile/api/profile/read.js
import axiosInstance from '@/lib/axios';

export async function readOrganizer() {
  try {
    const response = await axiosInstance.get('/users/me');
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('tokenType');
      throw new Error('Unauthorized. Authentication Expired');
    }
    throw error;
  }
}

export async function patchOrganizer(formData) {
  try {
    const response = await axiosInstance.patch('/users/me', formData);
    return response.data;
  } catch (error) {
    const message = error.response?.data || error.message;
    throw new Error('Failed to update profile: ' + JSON.stringify(message));
  }
}

// ✅ Delete organizer profile
export async function deleteOrganizer() {
  try {
    const response = await axiosInstance.delete('/users/me');
    return response.status === 200;
  } catch (error) {
    throw error;
  }
}

// ✅ Change organizer password
export async function patchPassword({ oldPassword, newPassword, confirmPassword }) {
  try {
    const response = await axiosInstance.patch('/users/me/password', {
      old_password: oldPassword,
      new_password: newPassword,
      confirm_new_password: confirmPassword,
    });
    return response.data;
  } catch (error) {
    const errData = error.response?.data;
    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error(`Password change failed: ${message}`);
  }
}

// ✅ Helper to get auth headers if needed
function getAuthHeaders() {
  const token = localStorage.getItem('authToken');
  const tokenType = localStorage.getItem('tokenType');
  if (!token || !tokenType) throw new Error('You are not authorized.');
  return { Authorization: `${tokenType} ${token}` };
}

// ✅ Fetch all security questions (admin)
export async function fetchSecurityQuestions() {
  try {
    const response = await axiosInstance.get('/admin/security_questions', {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    const errData = error.response?.data;
    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error(`Failed to fetch security questions: ${message}`);
  }
}

// ✅ Fetch current user’s security questions
export async function fetchUsrSecurityQuestions() {
  try {
    const response = await axiosInstance.get('/users/users_security_questions', {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) return []; // No questions set yet
    console.error('Failed to fetch user security questions:', error);
    throw new Error('Failed to fetch user security questions.');
  }
}

// ✅ Create user security questions
export async function createUsrSecurityQuestions(data) {
  try {
    console.log('📤 Sending payload:', data);
    const response = await axiosInstance.post('/users/users_security_questions', data, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    const errData = error.response?.data;
    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error(`Failed to save security question: ${message}`);
  }
}

// ✅ Update user security questions
export async function patchUsrSecurityQuestions(data) {
  try {
    console.log('📤 Sending payload:', data);
    const response = await axiosInstance.patch('/users/users_security_questions', data, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    const errData = error.response?.data;
    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error(`Failed to save security question: ${message}`);
  }
}